export default __webpack_public_path__ + "static/media/no_data.c730f981.svg";